















import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import OptionListBoxSelector from "../../system/selectors/OptionListBoxSelector.vue";
import { ProjectTeamSelectableMixin } from "./mixins/";

@Component({
  components: {
    OptionListBoxSelector,
  },
})
export default class ProjectTeamListSelector extends Mixins(ProjectTeamSelectableMixin) {
  @Prop({ default: false })
  isClearable: boolean;

  scrollIntoView(): void {
    (this.$refs.selector as OptionListBoxSelector).scrollIntoView();
  }

  @Watch("values")
  async onValuesChanged(newValue: any, oldValue: any): Promise<void> {
    await this.$nextTick();
    this.scrollIntoView();
  }

  @Emit()
  dblclick(e: PointerEvent): void {}
}
